import type { NexperienceFragment } from '@data-access/lib/gql/experience/documents'
import { tz } from '@date-fns/tz'
import { parseLocalDate } from '@utils/helpers'
import { formatDateWithShortYear } from '@utils/utils-format'
import { isSameDay } from 'date-fns'
import { DEFAULT_TIME_ZONE } from '@/lib/time-zone'

export function useExperienceOfferPeriod(experience: NexperienceFragment) {
  if (!experience.offerPeriodStart || !experience.offerPeriodEnd) return

  const startZone = experience.offerPeriodStart.timezone ?? DEFAULT_TIME_ZONE
  const endZone = experience.offerPeriodEnd.timezone ?? DEFAULT_TIME_ZONE
  const startDate = parseLocalDate(experience.offerPeriodStart)
  const endDate = parseLocalDate(experience.offerPeriodEnd)

  if (isSameDay(startDate, endDate, { in: tz(startZone) })) {
    return formatDateWithShortYear(startDate, startZone)
  }

  return `von ${formatDateWithShortYear(startDate, startZone)} bis ${formatDateWithShortYear(endDate, endZone)}`
}
